// @flow
import React from 'react';
import classnames from 'classnames';

import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';

import { themes } from './LayerHeaderButton.themes';

export type LayerHeaderButtonProps = {
  ariaHidden?: boolean,
  ariaLabel?: string,
  className?: string,
  dataTestId?: string,
  iconClassName?: string,
  iconName?: IconName,
  isActive?: boolean,
  label?: string,
  onClick: ?(e?: SyntheticEvent<>) => void,
  tabIndex?: number,
  theme?: string,
};

export function LayerHeaderButton(props: LayerHeaderButtonProps) {
  const {
    ariaHidden,
    ariaLabel,
    className,
    dataTestId,
    iconClassName,
    iconName,
    isActive,
    label,
    onClick,
    tabIndex,
    theme = 'default',
  } = props;

  if (!label && !iconName) return null;

  const { thIcon, thIconWidth, thLabel, thRoot } = themes[theme]({ isActive });

  return (
    <button
      aria-hidden={ariaHidden}
      aria-label={ariaLabel}
      className={classnames(className, thRoot)}
      data-testid={dataTestId}
      onClick={onClick}
      {...(tabIndex === -1 ? { tabIndex } : null)}
      type="button"
    >
      {!!iconName && (
        <Icon
          className={classnames(thIcon, iconClassName)}
          hasRtl
          name={iconName}
          width={thIconWidth}
        />
      )}
      {!!label && <span className={thLabel}>{label}</span>}
    </button>
  );
}
